import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { LayoutComponent, NavLink } from 'shared-frontend';
import { HeaderComponent, FooterComponent, NavBarComponent } from 'shared-frontend';
import { PERMISSION_SETS } from './core/roles.constants';

import { BackendUrlLogger } from 'shared-frontend';

@Component({
  selector: 'app-root',
  standalone: true,
  // imports: [
  //   FooterComponent,
  //   HeaderComponent,
  //   NavBarComponent,
  //   LayoutComponent,
  //   RouterOutlet
  // ],
  imports: [RouterOutlet, LayoutComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
    constructor(private _log: BackendUrlLogger) {} // Test BackendUrl injection by env
}
